import '../App.css';

const PunkIPA = () => {
    return (
        
            <div>
        
        <div className="appPages">
        <div className="navSpace"></div>
        <iframe title="PunkIPA App" src="https://punkipa.netlify.app/" width="100%" height="99.4%" ></iframe>
        </div>
        </div>
           

    )
    }
    export default PunkIPA   